import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default {
  __name: 'BasicSpinner',
  props: ['size', 'color'],
  setup(__props) {

const props = __props
const dimension = { small: 'h-5 w-5', medium: 'h-10 w-10', large: 'h-15 w-15', undefined: 'h-5 w-5', custom: '' }[
  props.size
]

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("svg", {
    class: _normalizeClass(["animate-spin", [_unref(dimension), props.color]]),
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      class: "opacity-25",
      cx: "12",
      cy: "12",
      r: "10",
      stroke: "currentColor",
      "stroke-width": "4"
    }, null, -1),
    _createElementVNode("path", {
      class: "opacity-75",
      fill: "currentColor",
      d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    }, null, -1)
  ]))], 2))
}
}

}